import { render, staticRenderFns } from "./NbnActiveOrderManagement.vue?vue&type=template&id=143b4a0b&scoped=true"
import script from "./NbnActiveOrderManagement.vue?vue&type=script&lang=js"
export * from "./NbnActiveOrderManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143b4a0b",
  null
  
)

export default component.exports